import React, { useContext } from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import { ProductContext } from "./context/Context";

const OptionModal = (props) => {
  const {
    state: { modalProduct, modalIsOpen },
    closeModal,
  } = useContext(ProductContext);

  const {
    id,
    company,
    title,
    img,
    price,
    discountPrice,
    info,
    inCart,
  } = modalProduct;

  return (
    <Modal
      isOpen={modalIsOpen}
      // onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      ariaHideApp={false}
      contentLabel="Selected Option"
      closeTimeoutMS={200}
      className="modal"
    >
      <h4>Item Added To The Cart</h4>
      <div className="single-shop-product">
        <div className="product-upper">
          <Link to="/details">
            <img src={img} alt="" />
          </Link>
        </div>
        <h2>
          <a href="" style={{ marginLeft: "2.5rem" }}>
            {title}
          </a>
        </h2>
        <div
          className="product-carousel-price"
          style={{ marginLeft: "2.5rem" }}
        >
          <ins>${price}</ins> <del>${discountPrice}</del>
        </div>
      </div>
      <div className="product-option-shop">
        <Link to="/" className="add_to_cart_button" onClick={closeModal}>
          <span>
            <i className="fa fa-shopping-cart"></i> store
          </span>
        </Link>
        <Link className="add_to_cart_button" to="/cart" onClick={closeModal}>
          Go to cart
        </Link>
      </div>
    </Modal>
  );
};

export default OptionModal;
